import { __awaiter } from "tslib";
/**
 * 组件使用场景：出价记录 (非弹窗)
 * */
import React, { Component } from 'react';
import { Table, Tabs } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch, getState } from '@@/store';
import { dealListValueShow } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
import styled from 'styled-components';
import styles from './style/index.less';
const Root = styled.div `
  display: flex;
  justify-content: flex-start;
  .tab-btn {
    padding: 0 7px;
    font-size: 12px;
    color: #666;
    background: #f2f3f5;
    border-radius: 2px;
    margin: 8px 8px 0 0;
  }
  .deal {
    background: rgba(255, 87, 26, 0.1);
    color: #ff571a;
  }
`;
const showSize = 20;
const mapStateToProps = (rootState) => ({
    record: rootState.offerRecord,
});
class OfferRecord extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    title: '买家信息',
                    width: 300,
                    dataIndex: 'buyerPhone',
                    render: (text, record) => {
                        const { realName = '', bidPlatformId, isDealPrice, status } = record;
                        return (<>
                <div style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}>
                  {(realName && text !== fontEndConfig.noValueReplace) ?
                            <>
                      <span style={{ width: '20%', textAlign: 'left' }}>{realName}</span>
                      <span>{this.changePhone(text)}</span>
                    </> : fontEndConfig.noValueReplace}
                </div>
                <Root>
                  <p className="tab-btn">{bidPlatformId === 10 ? '车易拍车商' : '自有车商'}</p>
                  {isDealPrice && <p className="tab-btn deal">成交</p>}
                  {status === 3 && <p className="tab-btn">已取消报价</p>}
                </Root>
              </>);
                    },
                },
                {
                    title: '出价金额',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'carPriceY',
                },
                {
                    title: '合手价',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'offerPriceY',
                },
                {
                    title: '佣金',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'brokerageY',
                },
                {
                    title: '服务费',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'commissionY',
                },
                {
                    title: '出价时间',
                    dataIndex: 'createTime',
                    width: 300,
                },
            ],
            pageSize: showSize,
        };
        this.tabChange = this.tabChange.bind(this);
        this.tableUpdate = this.tableUpdate.bind(this);
        this.updateData = this.updateData.bind(this);
        this.changePhone = this.changePhone.bind(this);
    }
    componentDidMount() {
        dispatch.offerRecord.updateData({ index: 1, size: 20, auctionId: this.props.id });
    }
    componentWillUnmount() {
        dispatch.offerRecord.resetState();
    }
    tableUpdate(index) {
        dispatch.offerRecord.updateData({ index, size: this.state.pageSize, auctionId: this.props.id });
    }
    updateData(index) {
        const { pageIndex, activeTab, pageIndexAuction } = this.props.record;
        const updateIndex = activeTab === '2' ? pageIndexAuction : pageIndex;
        dispatch.offerRecord.updateData({
            index: index || updateIndex,
            size: this.state.pageSize,
            auctionId: this.props.id,
        });
    }
    changePhone(phone) {
        return phone && phone.replace(/(^\d{3}|\d{4}\B)/g, '$1 ');
    }
    tabChange(activeKey) {
        return __awaiter(this, void 0, void 0, function* () {
            yield dispatch.offerRecord.SET_STATE({
                activeTab: activeKey,
            });
            dispatch.offerRecord.updateData({ index: 1, size: this.state.pageSize, auctionId: this.props.id });
        });
    }
    _renderCancellationSign() {
        const { type, tableData, offerAuctionMode, activeTab } = this.props.record;
        const showSign = type === 'offer' && offerAuctionMode === 1011 && activeTab === '2';
        if (!showSign) {
            return null;
        }
        const dataCancellationList = tableData.filter((item) => item.status === 2);
        return dataCancellationList.length > 0 ? (<div style={{
            position: 'absolute',
            zIndex: 1,
            right: '25px',
            top: '135px',
        }}>
        <img src="https://assets.souche.com/assets/sccimg/auctionSass/cancellate.png" alt="作废"/>
      </div>) : null;
    }
    _renderTab(key, title) {
        const { tabCustomFn } = this.props;
        return tabCustomFn ? tabCustomFn({
            tabType: key,
            tabTitle: title,
        }) : title;
    }
    render() {
        const { tableData, pageIndex, total, activeTab, loading, offerAuctionMode, pageIndexAuction, totalAuction, offerSessionMsg } = this.props.record;
        const { tableColumnsCustomFn } = this.props;
        const { columns, pageSize } = this.state;
        const tableColumns = tableColumnsCustomFn ? tableColumnsCustomFn({
            columns,
            sessionMsg: offerSessionMsg,
            updateFn: this.updateData,
        }) : columns;
        return (<>
        {(offerAuctionMode === 1011 || offerAuctionMode === 1021) && ( // 超级拍-现场拍 & 超级拍-车道拍
        <Tabs className={'tab_custom_style'} activeKey={activeTab} onChange={this.tabChange}>
              <Tabs.TabPane key={'1'} tab={this._renderTab(1, '投标出价')}/>
              <Tabs.TabPane key={'2'} tab={this._renderTab(2, '竞拍出价')}/>
            </Tabs>)}
        {this._renderCancellationSign()}
        <Table loading={loading} bordered columns={tableColumns} dataSource={dealListValueShow({
            gistData: tableColumns,
            data: tableData,
        })} className="draw_table_all_border" rowClassName={this.props.rowClassName} rowKey={'key'} pagination={{
            current: activeTab === '2' ? pageIndexAuction : pageIndex,
            pageSize,
            showQuickJumper: true,
            total: activeTab === '2' ? totalAuction : total,
            onChange: this.tableUpdate,
            showTotal: total => `共${total}条`,
        }}/>
      </>);
    }
}
OfferRecord.defaultProps = {
    rowClassName: (record) => {
        return record.status === 3 ? styles.cancel : '';
    },
};
export default connect(mapStateToProps)(OfferRecord);
export const updateOfferRecord = ({ updateTab, index }) => {
    const { pageIndex, pageIndexAuction, activeTab, id } = getState().offerRecord;
    const currentIndex = activeTab === 1 ? pageIndex : pageIndexAuction;
    if (updateTab !== undefined) {
        dispatch.offerRecord.SET_STATE({
            activeTab: `${updateTab}`,
        });
        setTimeout(() => {
            dispatch.offerRecord.updateData({ index: index || currentIndex, size: showSize, auctionId: id });
        });
    }
    else {
        dispatch.offerRecord.updateData({ index: index || currentIndex, size: showSize, auctionId: id });
    }
};
export const getOfferRecordCurrentIndex = () => {
    const { pageIndex, pageIndexAuction, activeTab } = getState().offerRecord;
    return activeTab === '1' ? pageIndex : pageIndexAuction;
};
